
import React from 'react';
import { Button } from '@/components/ui/button';
import { Info } from 'lucide-react';
import { useTour } from '@/contexts/TourContext';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface TourButtonProps {
  pageId: string;
  className?: string;
}

export const TourButton = ({ pageId, className }: TourButtonProps) => {
  const { startTour } = useTour();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="icon"
            className={className}
            onClick={() => startTour(pageId)}
          >
            <Info className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Start page tour</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
